import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../components/Layout/Breadcrumb";
import UserManualForm from "./UserManualForm";

import ScrollUp from "../../components/ScrollUpDown/ScrollUp";
import ScrollDown from "../../components/ScrollUpDown/ScrollDown";

const UpdateUserManual = (props: any) => {
  const { t } = useTranslation();
  let { type, id, user_manual_id } = useParams();
  document.title = `${t("Update")} ${t("user manual")} | ` + process.env.REACT_APP_NAME;

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: `/user-manual/list/${id}/${user_manual_id}`,
      label: t("User manual"),
      active: false,
    },
    {
      url: "#",
      label: `${t("Update")} ${t("user manual")}`,
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <ScrollUp />
      <ScrollDown top={"100px"} />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={`${t("Update")} ${t("user manual")}`}
            breadcrumbItems={breadcrumbItems}
          />

          <UserManualForm />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateUserManual;
